export * from './ogreport.component';
export * from './ogreport.service';



// WEBPACK FOOTER //
// ./src/app/ongoingreport/index.ts